import axios from "axios";

const configureAxios = backendURL => {
  axios.defaults.baseURL = backendURL;
};

export default configureAxios;

export const API_RESPONSE_STATUS_CODE = {
  SUCCESS: 200,
  UNAUTHORIZED: 401,
  BAD_REQUEST: 400,

  //Payment errors
  TOKEN_NOT_FOUND: 2002,
  TOKEN_ALREADY_PROCESSED: 2003,
  TOKEN_EXPIRED: 3001,
  MAXIMUM_RETRY_ATTEMPTS_REACHED: 3002,
  KNET_INIT_FAIL: 1001,
};



// WEBPACK FOOTER //
// ./src/config/axios.init.js